<template>
  <div>
    <!-- <div class="Header-Wrapper">
      <simple-header :label="$t('global.back')" @click="goBack" />
    </div> -->
    <vv-box :title="$t('progression.myProgression')">
      <div class="vv-box-progression">
        <div v-for="theme in themesQuiz" :key="theme.id" class="progression-main">
          <h2>{{ theme.title }}</h2>
          <progress-circle v-if="successQuiz(theme.id)" :isLocked="false" :percentage="100" :color="themeColor(theme.id)" :image="badgeImage(theme)" :changeImgSuccess="true"></progress-circle>
          <progress-circle v-else :isLocked="false" :percentage="themePercentage(theme.id)" :color="themeColor(theme.id)" :image="badgeImage(theme)" :changeImgSuccess="false"></progress-circle>
          <vv-button :customClass="'vv-button-progression white-variant'" @click="goToProgressionDetail(theme.id)">
            {{ $t('progression.checkMyProgression') }}
            <!-- <span class="arrow">></span> -->
          </vv-button>
        </div>
      </div>
    </vv-box>

    <!-- <vv-box :title="$t('progression.myBadges')">
      <div v-for="masterclassId in masterclassIds" :key="masterclassId">
        <masterclass-badges :masterclassId="masterclassId" />
      </div>
    </vv-box> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import badgeMixin from '@/mixins/badge'
import { VvBox, VvButton } from '@/components/common'
import SimpleHeader from '@/components/navigation/SimpleHeader.vue'
import MasterclassBadges from '@/components/userAccount/MasterclassBadges'
import ProgressCircle from '@/components/userAccount/ProgressCircle'

import { getThemePercentageQuiz, getThemeColor } from '@/helpers/userCompletion'

import { contentHasQuiz } from '@/store/modules/quiz/actions'
import remoteConfigMixin from '@/mixins/remoteConfig'

export default {
  name: 'UserProgression',
  components: { VvBox, MasterclassBadges, ProgressCircle, VvButton, SimpleHeader },
  mixins: [badgeMixin, remoteConfigMixin],
  computed: {
    ...mapGetters({
      themes: 'themes'
    }),
    masterclassIds() {
      return this.$store.state.lesson.theme.allIds
    },
    themesQuiz() {
      return this.themes.filter(e => this.hasQuiz(e.id) == true)
    }
  },
  mounted() {
  },
  methods: {

    themeHasBadge(themeId) {
      // let lessonStepWithQuizId = this.lessonsSteps.find(el => el.quizId != null)
      // let badge = null
      // if (lessonStepWithQuizId) {
      //   badge = this._getBadgeFromQuiz(lessonStepWithQuizId.quizId)
      // } else {
      //   badge = this._getBadgeFromMasterclass(this.theme.id)
      // }
      return this._getBadgeFromMasterclass(themeId)
    },
    badgeImage(theme) {
      let badge = this._getBadgeFromMasterclass(theme.id)
      return badge ? badge.image : theme.tileImage
    },
    hasQuiz(themeId) {
      return contentHasQuiz('masterclass', themeId, this.$store.state)
    },
    successQuiz(themeId) {
      let badge = this.themeHasBadge(themeId)
      // Check that the masterclass badge is in the acquired badges
      return this.hasQuiz(themeId) && badge && this.acquiredBadges.indexOf(badge.id) > -1 ? true : false
    },
    themePercentage(themeId) {
      return getThemePercentageQuiz(themeId)
    },
    themeColor(themeId) {
      return getThemeColor(themeId)
    },
    goToProgressionDetail(themeId) {
      this.$router.push({ name: 'userProgressionDetail', params: { themeId } })
    },
    goBack() {
      this.$router.push({ name: 'home' })
    }
  } 
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

progress-circle {
  margin-bottom: 0px;
}

.vv-box-progression {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .progression-main {
    flex: 1 0 20%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin: 10px;
    margin-bottom: 70px;

    h2 {
      text-align: center;
      height: 60px;
      margin-bottom: -20px;
    }
  }

  .vv-button-progression {
    transition: background-color 250ms ease-in-out;
  }

  .vv-button-progression:hover{
    background-color: #D00E4A;
    color: $font-button;
  }
}
</style>
